export default {
  LITE: 'LITE',
  STD: 'STD',
  ENT: 'ENT',
};
